import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { StaffregisterComponent } from "./component/staffregister/staffregister.component";


const routes: Routes = [
  {
    path: "",  component: StaffregisterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StaffregisterRoutingModule {}
